<template>
  <d-card class="sc-stats card-small">
      <d-card-header class="border-bottom">
          <h6 class="m-0">Last transactions</h6>
          <div class="block-handle"></div>
      </d-card-header>
      <d-card-body class="p-0">
          <template v-if="!isLoading && isLoaded">
              <last-transactions-list :transactions="transactions"/>
          </template>
          <d-container v-if="isLoading && !isLoaded" class="d-flex justify-content-center" fluid>
              <b-spinner class="m-auto" label="Spinning" />
          </d-container>
      </d-card-body>
      <d-card-footer class="border-top">
          <d-row>
              <d-col class="text-right view-report">
                    <router-link to="/transactions">View all transactions &rarr;</router-link>
              </d-col>
          </d-row>
      </d-card-footer>
  </d-card>
</template>

<script>
import LastTransactionsList from "@/components/transactions/LastTransactions/LastTransactionsList";
import {TransactionService} from "@/main";
import DateHelper from "@/helpers/date";

export default {
    props: ['websiteId'],

    components: {
        LastTransactionsList
    },
    data() {
        return {
            startDate: new Date(DateHelper.getDateThisMonth()),
            endDate: new Date(DateHelper.getDateToday()),
            transactions: [],
            isLoading: false,
            isLoaded: false,
            websiteIds: [],
        };
    },

    watch: {
        websiteId: function (newVal, oldVal) { // todo use events
            if (newVal === null) {
                this.websiteIds = []
            } else {
                this.websiteIds = [Number(newVal)]
            }
            this.getLastTransactions()
        }
    },

    methods: {
        async getLastTransactions() {
            this.isLoading = true
            try {
                let transactions = await TransactionService.getFilteredTransactionsWithLimit({
                    startDate: this.startDate,
                    endDate: this.endDate,
                    websites: this.websiteIds
                }, 5);
                this.transactions = transactions.transactions.data;
                this.isLoading = false;
                this.isLoaded = true;
            } catch (e) {
                this.isLoading = false;
                this.isLoaded = false;
                this.showNotification(
                    "warn",
                    "Oops! we have a problem",
                    "Cant get transactions"
                );
                throw e
            }
        },
    },

    created() {
        this.getLastTransactions()
    }
};
</script>
